
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promote-your-business",
      function () {
        return require("private-next-pages/promote-your-business/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promote-your-business"])
      });
    }
  